import React from 'react';
import { reduxForm } from 'redux-form';
import MultipleCheckboxSelect from 'components/Fields/ReduxForm/MultipleCheckboxSelect';
import Header from 'pages/Employees/Header';
import PropTypes from 'prop-types';
import withFeatureFlags from 'hocs/withFeatureFlags';
import { Link } from 'react-router';
import WarningMessage from 'components/WarningMessage';
import styles from './PinForm.css';

class PinForm extends React.Component {
  render() {
    const { pinAccessImprovement } = this.props;
    const classNames = pinAccessImprovement ? styles.wrapper : '';

    return (
      <div className={styles.form}>
        {pinAccessImprovement ? (
          <Header title="LIST OF FEATURES" />
        ) : (
          <div>
            <Header title="REQUIRE EMPLOYEES TO ENTER 4-DIGIT PIN" />
            <div className={styles.description}>
              Allow employee to sign in to your Point of Sale using their email
              and access the following using a 4-digit PIN.
              <div className={styles['description-subtext']}>
                To allow employees access for these permissions instead, go to{' '}
                <Link to="/employees/role" target="_blank">
                  Employee Access
                </Link>
                .
              </div>
            </div>
            <div
              style={{ marginTop: '20px', marginBottom: '40px' }}
              className={styles['app-version-warning']}
            >
              <WarningMessage
                message="Pin Access requires at least Moka v.26.2 on iOS and Moka v.15.9.1 on Android."
                iconStyle={`circle`}
              />
            </div>
          </div>
        )}
        <div className={classNames}>
          {this.props.allowedFields.map((field, index) => (
            <div>
              <MultipleCheckboxSelect
                key={index}
                label={field.label}
                sublabel={field.description}
                name={field.name}
                disabled={false} // diganti jadi always enable karena ada pengeekan use-case yang gak dilaukan lagi (disable button if manager/staff doesn't have access to menu on app
                wrapperClassName={styles['checkbox-field']}
              />
              <hr className={styles.separator} />
            </div>
          ))}
          <div className="row" style={{ paddingBottom: '15vh' }}>
            <div className="col-lg-12">
              <button
                className={`${styles['btn-save']} btn btn-primary pull-right`}
                onClick={this.props.handleSubmit}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PinForm.propTypes = {
  allowedFields: PropTypes.array,
};
const mapForm = {
  form: 'pin',
};

const mapFlagsToProps = flags => ({
  pinAccessImprovement: flags.pinAccessImprovement,
});

export default withFeatureFlags(mapFlagsToProps)(reduxForm(mapForm)(PinForm));
